import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { TitleScene } from './scenes/TitleScene';
import { WorldMapScene } from './scenes/WorldMapScene';
import { HouseScene } from './scenes/HouseScene';
import { TransitionScene } from './scenes/TransitionScene';
// World 1 Levels
import { BlanketBossScene } from './scenes/levels/BlanketBossScene';
import { ClothesChaoScene } from './scenes/levels/ClothesChaoScene';
import { MissingShoeScene } from './scenes/levels/MissingShoeScene';
import { MorningTitanScene } from './scenes/levels/MorningTitanScene';
import { GAME_CONFIG } from './config/game';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: GAME_CONFIG.backgroundColor,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_CONFIG.width,
    height: GAME_CONFIG.height,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 }, // No gravity for top-down
      debug: GAME_CONFIG.debug,
    },
  },
  render: {
    pixelArt: true,
    antialias: false,
    roundPixels: true,
  },
  input: {
    activePointers: 3,  // Support multi-touch
    touch: {
      target: null,     // Use default canvas
      capture: true,    // Capture touch events
    },
  },
  scene: [
    BootScene,
    PreloadScene,
    TitleScene,
    WorldMapScene,
    HouseScene,
    TransitionScene,
    // World 1 Levels
    BlanketBossScene,
    ClothesChaoScene,
    MissingShoeScene,
    MorningTitanScene,
  ],
};

new Phaser.Game(config);

